// extracted by mini-css-extract-plugin
export var attachmentContainer = "_jf-0";
export var fileList = "_jf-2";
export var removeFileButton = "_jf-1";